
webpack.register(
    'modules/hero/hero',
    function() {
        return import('modules/hero/hero');
    },
    true
);

webpack.register(
    'components/satisfi-button/satisfi-button',
    function() {
        return import('components/satisfi-button/satisfi-button');
    },
    true
);